import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from '../elements/Navbar';
import { Link, useParams } from 'react-router-dom';

const KnowledgeBaseArticle = () => {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  const userEmail = localStorage.getItem('userEmail');
  const canEdit = userEmail === 'mario@getpop.co';

  const API_BASE = process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_API_URL_BASE_DEV
    : process.env.REACT_APP_API_URL_BASE_PROD;

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/knowledge_base/articles/${slug}`);
        setArticle(res.data);
      } catch (e) {
        console.error('Failed to fetch article:', e);
      } finally {
        setLoading(false);
      }
    };
    fetchArticle();
  }, [API_BASE, slug]);

  if (loading) {
    return (
      <div>
        <Navbar />
        <div className="container mx-auto px-4 max-w-3xl mt-8 text-gray-400 text-sm">Loading...</div>
      </div>
    );
  }

  if (!article) {
    return (
      <div>
        <Navbar />
        <div className="container mx-auto px-4 max-w-3xl mt-8">
          <p className="text-gray-500">Article not found.</p>
          <Link to="/knowledge-base" className="text-indigo-600 hover:underline text-sm mt-2 block">← Back to Knowledge Base</Link>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Navbar />
      <div className="container mx-auto mb-32 px-4 max-w-3xl">
        <div className="mb-6">
          <Link to="/knowledge-base" className="text-indigo-600 hover:underline text-sm">
            ← Back to Knowledge Base
          </Link>
        </div>

        <div className="flex justify-between items-start mb-8">
          <div>
            {article.category && (
              <span className="inline-block bg-indigo-50 text-indigo-600 text-xs font-medium px-2.5 py-0.5 rounded mb-2">
                {article.category}
              </span>
            )}
            <h1 className="text-3xl font-bold text-gray-900">{article.title}</h1>
            <p className="text-sm text-gray-400 mt-2">
              {article.author && <span className="mr-3">By {article.author}</span>}
              <span>
                {new Date(article.created_at).toLocaleDateString('en-US', {
                  year: 'numeric', month: 'long', day: 'numeric'
                })}
              </span>
            </p>
          </div>
          {canEdit && (
            <Link
              to={`/knowledge-base/${slug}/edit`}
              className="bg-gray-100 text-gray-700 px-3 py-2 rounded-md hover:bg-gray-200 text-sm font-medium"
            >
              Edit
            </Link>
          )}
        </div>

        <div
          className="prose prose-gray max-w-none"
          dangerouslySetInnerHTML={{ __html: article.body }}
        />
      </div>
    </div>
  );
};

export default KnowledgeBaseArticle;
